import { IMapperType } from '@/Emulator';
import { Cartridge }   from '@/Emulator/IO';
import { IMapper }     from '@/Emulator/Mapper/IMapper';
import { Mapper000 }   from '@/Emulator/Mapper/Mapper000';
import { Mapper004 }   from '@/Emulator/Mapper/Mapper004';
import { Mapper066 }   from '@/Emulator/Mapper/Mapper066';

export class MapperFactory
{
    private static types: IMapperType[] = [
        Mapper000,
        Mapper004,
        Mapper066,
    ];

    public static make(cartridge: Cartridge): IMapper
    {
        for (const Type of MapperFactory.types) {
            if (Type.supports(cartridge)) {
                return new Type(cartridge);
            }
        }

        throw new Error(`Unsupported cartridge. Mapper #${cartridge.mapperId.toString(10).padStart(3, '0')} is not implemented.`);
    }
}
